import {$http} from '@/utils/https'
import {

    SET_PRODUCT_DATA,
    SET_PRODUCT_ATTRIBUTES, SET_POPULAR_PRODUCTS,
} from '../mutation-types';
import {

    PRODUCT_DATA,
    POPULAR_PRODUCTS
} from '../action-types';


const state = {
    productData: '',
    productAttributes: '',
    popularProducts: ''
};
const actions = {
    [POPULAR_PRODUCTS]: async ({commit}) => {
        // commit(CHANGE_LOADING_LIST, true);
        try {
            const response = await $http.get(`v1/products/popular`);

            commit(SET_POPULAR_PRODUCTS, response.data?.data);
        } catch (e) {
            throw e;
        } finally {
            // commit(CHANGE_LOADING_LIST, false);
        }
    },
    [PRODUCT_DATA]: async ({commit}, payload) => {
        // commit(CHANGE_LOADING_LIST, true);
        try {
            const response = await $http.get(`v1/products/${payload.slug}`);

            commit(SET_PRODUCT_DATA, response.data?.data);
            commit(SET_PRODUCT_ATTRIBUTES, response.data?.data?.product_attributes);
        } catch (e) {
            throw e;
        } finally {
            // commit(CHANGE_LOADING_LIST, false);
        }
    },
}

const getters = {
    productData: state => state.productData,
    productAttributes: state => state.productAttributes,
    popularProducts: state => state.popularProducts
};

const mutations = {
    [SET_PRODUCT_DATA](state, list) {
        state.productData = list
    },
    [SET_PRODUCT_ATTRIBUTES](state, list) {
        state.productAttributes = list
    },
    [SET_POPULAR_PRODUCTS](state, list) {
        state.popularProducts = list
    }
};
export default {
    state,
    getters,
    actions,
    mutations,
}
